import { useMediaQuery as useMUIMediaQuery, Theme } from '@mui/material' // eslint-disable-line no-restricted-imports
import { useClientOnlyRender } from './useClientOnlyRender'

export interface IMediaQueryHookOptions {
  defaultMatches?: boolean
}

/**
 * Enhanced version of useMediaQuery, with improved support for SSR.
 * During SSR, the hook causes UI to not render until the nearest Suspense boundary.
 *
 * @param query The media query to test for match.
 * @param options Additional options.
 * @returns A boolean indicating whether the provided media query evaluates to true.
 */
export function useMediaQuery(query: string | ((theme: Theme) => string), options?: IMediaQueryHookOptions): boolean {
  useClientOnlyRender()

  return useMUIMediaQuery(query, options)
}
